// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1TwM4","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2PgQa","obliqueLine":"membershipbadge_obliqueLine__pkOT4"};